export function validateColumns(data, columns, mapper = null) {
    let valid = true;
    const items = [];
    const raw = [];
    const errors = [];
    data.forEach((item) => {
        const tmp = {};
        const row = {};
        columns.forEach((c) => {
            if (item[c.slug]) {
                switch (c.type) {
                    case Number:
                        const n = parseNumber(item[c.slug]);
                        tmp[c.slug] = {
                            value: n != null ? `${n}` : '',
                            error: !n
                        };
                        row[c.slug] = n;
                        break;
                    case String:
                        tmp[c.slug] = {
                            value: item[c.slug] != null ? `${item[c.slug]}` : '',
                            error: !`${item[c.slug]}`
                        };
                        row[c.slug] = `${item[c.slug]}`;
                        break;
                }
            }
            else {
                valid = valid && !c.required;
                row[c.slug] = null;
                tmp[c.slug] = {
                    value: '',
                    error: !`${item[c.slug]}` && !!c.required
                };
            }
        });
        raw.push(row);
        items.push(tmp);
    });
    items.forEach((item, index) => {
        Object.keys(item).forEach((key) => {
            if (item[key].error) {
                errors.push(`Se ha presentado un error en la fila: ${index + 1} y la columna: ${key}`);
            }
        });
    });
    return {
        items,
        raw: mapper ? raw.map(mapper) : raw,
        valid,
        errors
    };
}
export const itemMapper = (item) => ({
    number: item['item'],
    group: item['grupo'],
    code: item['codigo-institucional'],
    name: item['descripcion-producto'],
    quantity: item['cantidad-solicitada'],
    roof: item['precio-techo'],
    disabled: true
});
export function parseNumber(str) {
    const a = Number(str);
    if (!isNaN(a)) {
        return a;
    }
    else {
        const countDots = [...str].filter(s => s === '.').length;
        const countComma = [...str].filter(s => s === ',').length;
        if ((countDots === 0 || countDots > 1) && countComma === 1) {
            const n1 = Number(str.replace('.', '').replace(',', '.'));
            return !isNaN(n1) ? n1 : null;
        }
        else if (countDots <= 1 && countComma > 1) {
            const n2 = Number(str.replace(',', ''));
            return !isNaN(n2) ? n2 : null;
        }
        else {
            return null;
        }
    }
}
